import React from 'react';
import ActionIconButton from './ActionIconButton';

const EditButton = ({title = 'Editar', ...props}) => (
    <ActionIconButton variant="edit" title={title} {...props}/>
);

export default EditButton;
